/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Categories = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 19">
      <path d="M19 18.5L1 18.5C.723857625 18.5.5 18.2761424.5 18L.5 8.85C.5 8.57385763.723857625 8.35 1 8.35L19 8.35C19.2761424 8.35 19.5 8.57385763 19.5 8.85L19.5 18C19.5 18.2761424 19.2761424 18.5 19 18.5zM1.5 17.5L18.5 17.5 18.5 9.35 1.5 9.35 1.5 17.5zM17 5.5L3 5.5C2.72385763 5.5 2.5 5.27614237 2.5 5 2.5 4.72385763 2.72385763 4.5 3 4.5L17 4.5C17.2761424 4.5 17.5 4.72385763 17.5 5 17.5 5.27614237 17.2761424 5.5 17 5.5zM15 1.5L5 1.5C4.72385763 1.5 4.5 1.27614237 4.5 1 4.5.723857625 4.72385763.5 5 .5L15 .5C15.2761424.5 15.5.723857625 15.5 1 15.5 1.27614237 15.2761424 1.5 15 1.5z" />
    </BaseSvgIcon>
  )
}

export default Categories
